module.exports = __webpack_public_path__ + "static/media/summary-list.a973979f.png";